import React from "react";

import withStyles from "@material-ui/styles/withStyles";

import {
  Create,
  Edit,
  Show,
  List,
  SimpleShowLayout,
  SimpleForm,
  TextInput,
  TextField,
  required,
  Datagrid,
  // ShowButton,
  EditButton
  //   DeleteButton
} from "jazasoft";

const inputOptions = {
  xs: 12,
  sm: 3,
  fullWidth: true,
  options: { fullWidth: true }
};

const createStyle = theme => ({});

export const CreateApps = withStyles(createStyle)(({ classes, ...props }) => {
  return (
    <Create {...props}>
      <SimpleForm className={classes.form} redirect="home">
        <TextInput source="appId" validate={[required()]} {...inputOptions} />
        <TextInput source="name" validate={[required()]} {...inputOptions} />
        <TextInput source="endpoint" {...inputOptions} />
        <TextInput source="desc" {...inputOptions} />
      </SimpleForm>
    </Create>
  );
});

const editStyle = theme => ({});

export const EditApp = withStyles(editStyle)(({ classes, ...props }) => {
  return (
    <Edit {...props} className={classes.form} redirect="home">
      <SimpleForm>
        <TextInput source="appId" validate={[required()]} {...inputOptions} />
        <TextInput source="name" validate={[required()]} {...inputOptions} />
        <TextInput source="endpoint" {...inputOptions} />
        <TextInput source="desc" {...inputOptions} />
      </SimpleForm>
    </Edit>
  );
});

const homeStyle = theme => ({
  buttonEdit: {
    width: theme.spacing(14)
  },
  buttonDelete: {
    width: theme.spacing(16)
  }
});

export const AppHome = withStyles(homeStyle)(({ classes, ...props }) => {
  return (
    <List {...props}>
      <Datagrid>
        <TextField source="name" />
        <TextField source="appId" />
        <TextField source="endpoint" />
        <TextField source="desc" />
        {/* <ShowButton cellClassName={classes.buttonEdit} /> */}
        <EditButton cellClassName={classes.buttonEdit} />
        {/* <DeleteButton cellClassName={classes.buttonDelete} /> */}
      </Datagrid>
    </List>
  );
});

const fieldOptions = {
  xs: 12,
  sm: 4
};

const viewStyle = theme => ({});

export const ViewApp = withStyles(viewStyle)(({ classes, ...props }) => {
  return (
    <Show {...props}>
      <SimpleShowLayout>
        <TextField source="name" {...fieldOptions} />
        <TextField source="appPrefix" {...fieldOptions} />
        <TextField source="appId" {...fieldOptions} />
        <TextField source="endpoint" {...fieldOptions} />
        <TextField source="desc" {...fieldOptions} />
      </SimpleShowLayout>
    </Show>
  );
});
